import {
  FileSearch,
  Target,
  FileText,
  CheckCircle,
  TrendingUp,
  PieChart,
  Users2,
  Calculator,
  Globe2,
  Scale,
  Briefcase,
  Shield,
  ArrowRight
} from "lucide-react";


export default function TenderWealthTaxAdvisory() {
  const sections = [
    {
      id: "tender-consultancy",
      title: "Tender-Related Guidance & Advisory",
      subtitle: "Wealth Management, Financial Services & Allied Sectors",
      icon: FileSearch,
      heroImage: "https://images.pexels.com/photos/6693655/pexels-photo-6693655.jpeg?auto=compress&cs=tinysrgb&w=1200",
      subsections: [
        {
          icon: Target,
          title: "Tender Identification & Qualification",
          description: "Strategic tender intelligence and qualification assessment",
          points: [
            "Identification of relevant tenders across ministries, PSUs, regulators, and public-sector entities",
            "Tender tracking across national and state e-procurement portals",
            "Eligibility, compliance, and bid qualification assessment",
            "Bid / No-Bid advisory"
          ],
          image: "https://images.pexels.com/photos/7688336/pexels-photo-7688336.jpeg?auto=compress&cs=tinysrgb&w=800"
        },
        {
          icon: FileText,
          title: "Tender Strategy & Bid Advisory",
          description: "Comprehensive bid strategy and positioning support",
          points: [
            "Bid strategy formulation and positioning",
            "Technical and commercial bid structuring advisory",
            "Compliance matrix preparation and risk assessment",
            "Consortium, JV, or partner structuring advisory"
          ],
          image: "https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=800"
        },
        {
          icon: FileText,
          title: "Documentation & Submission Support",
          description: "End-to-end documentation and submission assistance",
          points: [
            "Review and advisory on RFP, RFQ, EOI, and NIT documents",
            "Technical proposal review and enhancement",
            "Commercial and financial bid advisory",
            "Pre-bid queries, clarifications, and corrigenda tracking"
          ],
          image: "https://images.pexels.com/photos/4226140/pexels-photo-4226140.jpeg?auto=compress&cs=tinysrgb&w=800"
        },
        {
          icon: CheckCircle,
          title: "Evaluation & Post-Award Advisory",
          description: "Support through evaluation, award, and implementation",
          points: [
            "Support during technical and financial evaluations",
            "Negotiation and clarification advisory",
            "Contract finalization and award support",
            "Post-award compliance and performance monitoring guidance"
          ],
          image: "https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=800"
        }
      ]
    },
    {
      id: "wealth-management",
      title: "Wealth Management Advisory Services",
      subtitle: "Comprehensive wealth solutions for individuals and institutions",
      icon: TrendingUp,
      heroImage: "https://images.pexels.com/photos/730564/pexels-photo-730564.jpeg?auto=compress&cs=tinysrgb&w=1200",
      subsections: [
        {
          icon: PieChart,
          title: "Wealth Structuring & Planning",
          description: "Strategic wealth planning and asset allocation",
          points: [
            "Comprehensive wealth assessment and goal-based planning",
            "Asset allocation and portfolio structuring advisory",
            "Risk profiling and investment suitability assessment",
            "Succession and inheritance planning"
          ],
          image: "https://images.pexels.com/photos/6801648/pexels-photo-6801648.jpeg?auto=compress&cs=tinysrgb&w=800"
        },
        {
          icon: TrendingUp,
          title: "Investment & Portfolio Advisory",
          description: "Expert investment guidance across asset classes",
          points: [
            "Advisory on mutual funds, bonds, PMS, AIFs, and alternatives",
            "Capital markets and structured product advisory",
            "ESG and sustainable investment advisory",
            "Portfolio review and rebalancing"
          ],
          image: "https://images.pexels.com/photos/7567443/pexels-photo-7567443.jpeg?auto=compress&cs=tinysrgb&w=800"
        },
        {
          icon: Users2,
          title: "Institutional, HNI & Family Office Advisory",
          description: "Tailored solutions for high net worth clients",
          points: [
            "Wealth advisory for HNIs, UHNWIs, trusts, and institutions",
            "Family office structuring and advisory",
            "Endowment, corpus, and retirement planning"
          ],
          image: "https://images.pexels.com/photos/3184405/pexels-photo-3184405.jpeg?auto=compress&cs=tinysrgb&w=800"
        }
      ]
    },
    {
      id: "taxation-advisory",
      title: "Taxation Advisory Services",
      subtitle: "Comprehensive tax planning and compliance solutions",
      icon: Calculator,
      heroImage: "https://images.pexels.com/photos/6863332/pexels-photo-6863332.jpeg?auto=compress&cs=tinysrgb&w=1200",
      subsections: [
        {
          icon: Calculator,
          title: "Domestic Tax Advisory",
          description: "Strategic direct tax planning and compliance",
          points: [
            "Direct tax advisory for individuals, corporates, banks, and financial institutions",
            "Tax planning and compliance support",
            "Capital gains, investment, and transaction tax advisory",
            "Tax audit and assessment support",
            "Representation before tax authorities"
          ],
          image: "https://images.pexels.com/photos/8761732/pexels-photo-8761732.jpeg?auto=compress&cs=tinysrgb&w=800"
        },
        {
          icon: Scale,
          title: "Indirect Tax Advisory",
          description: "GST compliance and optimization services",
          points: [
            "GST advisory and compliance",
            "GST implications for banking and wealth management services",
            "Input tax credit optimization",
            "Litigation and dispute resolution support"
          ],
          image: "https://images.pexels.com/photos/5668838/pexels-photo-5668838.jpeg?auto=compress&cs=tinysrgb&w=800"
        }
      ]
    },
    {
      id: "international-tax",
      title: "Global & International Tax Advisory",
      subtitle: "Cross-border tax structuring and compliance",
      icon: Globe2,
      heroImage: "https://images.pexels.com/photos/3184287/pexels-photo-3184287.jpeg?auto=compress&cs=tinysrgb&w=1200",
      subsections: [
        {
          icon: Globe2,
          title: "Cross-Border Tax Structuring",
          description: "International tax planning and optimization",
          points: [
            "International tax planning and structuring",
            "Advisory on cross-border investments and remittances",
            "DTAA interpretation and application",
            "Withholding tax advisory"
          ],
          image: "https://images.pexels.com/photos/3183153/pexels-photo-3183153.jpeg?auto=compress&cs=tinysrgb&w=800"
        },
        {
          icon: Briefcase,
          title: "Transfer Pricing Advisory",
          description: "Comprehensive transfer pricing solutions",
          points: [
            "Transfer pricing policy design and documentation",
            "Benchmarking and compliance support",
            "Advisory on inter-company and cross-border transactions",
            "Audit and litigation support"
          ],
          image: "https://images.pexels.com/photos/3184339/pexels-photo-3184339.jpeg?auto=compress&cs=tinysrgb&w=800"
        },
        {
          icon: Users2,
          title: "Global Mobility & Expatriate Tax",
          description: "Expatriate taxation and global employment advisory",
          points: [
            "Expatriate and global employee tax advisory",
            "Payroll and social security advisory",
            "Tax equalization and protection policies"
          ],
          image: "https://images.pexels.com/photos/3184357/pexels-photo-3184357.jpeg?auto=compress&cs=tinysrgb&w=800"
        },
        {
          icon: Shield,
          title: "BEPS & Global Compliance",
          description: "International compliance and reporting frameworks",
          points: [
            "BEPS impact assessment and advisory",
            "Country-by-Country Reporting (CbCR)",
            "FATCA / CRS compliance advisory",
            "Global disclosure and reporting support"
          ],
          image: "https://images.pexels.com/photos/8296877/pexels-photo-8296877.jpeg?auto=compress&cs=tinysrgb&w=800"
        }
      ]
    }
  ];


  return (
    <div className="min-h-screen bg-white">
      {/* Main Hero */}
      <section className="bg-gradient-to-r from-yellow-600 to-yellow-700 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center max-w-4xl mx-auto">
            <h1
              className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Specialized Advisory Services
            </h1>
            <p className="text-xl md:text-2xl text-yellow-50 mb-4">
              Tender Consultancy, Wealth Management & Taxation Advisory
            </p>
            <p className="text-yellow-100 text-lg">
              Comprehensive solutions across tenders, wealth planning, and domestic & international taxation
            </p>
          </div>
        </div>
      </section>


      {/* Render Each Major Section */}
      {sections.map((section, sectionIndex) => (
        <div key={section.id}>
          {/* Section Hero */}
          <section className={`py-16 ${sectionIndex % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`}>
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="grid lg:grid-cols-2 gap-8 items-center">
                <div className={sectionIndex % 2 === 0 ? '' : 'order-last'}>
                  <div className="inline-flex items-center gap-2 px-4 py-2 bg-yellow-100 text-yellow-700 rounded-full text-sm font-semibold mb-4">
                    <section.icon className="w-4 h-4" />
                    <span>Service Area {sectionIndex + 1}</span>
                  </div>
                  <h2
                    className="text-3xl md:text-4xl font-bold mb-4 text-black"
                    style={{ fontFamily: "'Playfair Display', serif" }}
                  >
                    {section.title}
                  </h2>
                  <p className="text-lg text-gray-600 mb-6">
                    {section.subtitle}
                  </p>
                  <div className="flex gap-4">
                    <a
                      href="/contact"
                      className="px-6 py-3 bg-yellow-600 text-white font-semibold rounded-lg hover:bg-yellow-700 transition-all duration-300"
                    >
                      Get Started
                    </a>
                    <a
                      href="#services"
                      className="px-6 py-3 border-2 border-yellow-600 text-yellow-600 font-semibold rounded-lg hover:bg-yellow-50 transition-all duration-300"
                    >
                      Learn More
                    </a>
                  </div>
                </div>
                <div className="rounded-2xl overflow-hidden shadow-2xl">
                  <img
                    src={section.heroImage}
                    alt={section.title}
                    className="w-full h-96 object-cover"
                    onError={(e) => {
                      e.target.src = "https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=1200";
                    }}
                  />
                </div>
              </div>
            </div>
          </section>


          {/* Subsections Grid */}
          <section id="services" className={`py-16 ${sectionIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}>
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="grid md:grid-cols-2 gap-8">
                {section.subsections.map((subsection, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-gray-100 hover:border-yellow-500 group"
                  >
                    {/* Subsection Image */}
                    <div className="relative h-48 overflow-hidden">
                      <img
                        src={subsection.image}
                        alt={subsection.title}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                        onError={(e) => {
                          e.target.src = "https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=800";
                        }}
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                      <div className="absolute bottom-4 left-4 flex items-center gap-3">
                        <div className="p-3 bg-yellow-500 rounded-lg">
                          <subsection.icon className="w-6 h-6 text-white" />
                        </div>
                        <h3 className="text-xl font-bold text-white">
                          {subsection.title}
                        </h3>
                      </div>
                    </div>


                    {/* Subsection Content */}
                    <div className="p-6">
                      <p className="text-yellow-600 font-semibold text-sm mb-4">
                        {subsection.description}
                      </p>
                      <ul className="space-y-2">
                        {subsection.points.map((point, idx) => (
                          <li key={idx} className="flex items-start gap-2">
                            <div className="w-1.5 h-1.5 bg-yellow-500 rounded-full mt-2 flex-shrink-0"></div>
                            <span className="text-gray-600 text-sm leading-relaxed">
                              {point}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>


                    {/* CTA */}
                    <div className="px-6 pb-6">
                      <a
                        href="/contact"
                        className="block w-full text-center px-4 py-2 bg-gray-50 text-yellow-600 font-semibold rounded-lg hover:bg-yellow-600 hover:text-white transition-all duration-300"
                      >
                        Explore This Service
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>


          {/* Divider */}
          {sectionIndex < sections.length - 1 && (
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <div className="border-t-2 border-gray-200"></div>
            </div>
          )}
        </div>
      ))}


      {/* Why Choose Us */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-black">
              Why Choose Our Advisory Services?
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto"></div>
          </div>


          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 text-center border-t-4 border-yellow-500">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Target className="w-8 h-8 text-yellow-600" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-black">500+ Tenders</h3>
              <p className="text-gray-600">Successfully advised and won</p>
            </div>


            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 text-center border-t-4 border-yellow-500">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <TrendingUp className="w-8 h-8 text-yellow-600" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-black">₹5000Cr+</h3>
              <p className="text-gray-600">Assets under advisory</p>
            </div>


            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 text-center border-t-4 border-yellow-500">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Globe2 className="w-8 h-8 text-yellow-600" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-black">25+ Countries</h3>
              <p className="text-gray-600">Global tax advisory coverage</p>
            </div>


            <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 text-center border-t-4 border-yellow-500">
              <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <CheckCircle className="w-8 h-8 text-yellow-600" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-black">98%</h3>
              <p className="text-gray-600">Client satisfaction rate</p>
            </div>
          </div>
        </div>
      </section>


      {/* CTA */}
      <section className="py-20 bg-gradient-to-r from-yellow-600 to-yellow-700 text-white">
        <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Ready to Transform Your Business Strategy?
          </h2>
          <p className="text-xl text-yellow-50 mb-8">
            Whether you need tender advisory, wealth management, or tax planning expertise,
            our team is ready to guide you to success.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-yellow-600 font-bold rounded-lg hover:bg-gray-100 transition-all duration-300 shadow-lg"
            >
              Schedule a Consultation
              <ArrowRight className="w-5 h-5 ml-2" />
            </a>
            <a
              href="tel:+919999999999"
              className="inline-flex items-center justify-center px-8 py-4 border-2 border-white text-white font-bold rounded-lg hover:bg-white hover:text-yellow-600 transition-all duration-300"
            >
              Call +91 99999 99999
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
